import React, { useState, useEffect } from "react";
import { getData } from "../../../CommonElements/Functions/PostGetFun";
import { API } from "../../../api/API";
import { Card, CardBody, Col, CardHeader } from "reactstrap";
import CardHeaderSpan from "../../../Utils/CommonComponents/CardHeaderSpan";
import Chart from "react-google-charts";
import MonthDropdown from "../../CommonCompo/MonthDropdown";
import { GoogleChartWrapperChartType } from "react-google-charts";
type StatusCounts = Record<string, number>;
type ApiResponse = Record<string, StatusCounts>;
const MtpStatusByDesignation = () => {
  const [mtpStatusByDesignation, setMtpStatusByDesignation] =
    useState<ApiResponse>({});
  const [selectedMonth, setSelectedMonth] = useState("");

  useEffect(() => {
    const getMtpStatusByDesignation = async () => {
        if (!selectedMonth) return; 
      const serverUrl = localStorage.getItem("serverUrl");
      if (!serverUrl) {
        console.error("Server URL not found in localStorage.");
        return [];
      }

      const url = `${serverUrl}${API.mtpStatusByDesignation}`;
      console.log("============mtpStatusByDesignation============", url);

      const params = {
        moye: selectedMonth,
      };

      try {
        const { status, data } = await getData(url, true,  params );

        if (status === 200 && data.data) {
             console.log("API DATA:", data.data)
          setMtpStatusByDesignation(data.data);
        } else {
          console.error("Failed to fetch effort report data");
        }
      } catch (error) {
        console.error("Error fetching effort report:", error);
      }
    };
    getMtpStatusByDesignation();
  }, [selectedMonth]);

  const buildChartData = (apiData: ApiResponse): (string | number)[][] => {
    if (!apiData || Object.keys(apiData).length === 0) return [];

    const firstDesignation = Object.keys(apiData)[0];
    if (!firstDesignation) return [];

    const statuses = Object.keys(apiData[firstDesignation]);

    const header: (string | number)[] = ["Designation", ...statuses];

    const rows = Object.entries(apiData).map(([designation, statusObj]) => [
      designation,
      ...statuses.map((status) => statusObj[status] ?? 0),
    ]);

    return [header, ...rows];
  };

  const chartData = buildChartData(mtpStatusByDesignation);

  interface ChartConfig {
    width: string;
    height: string;
    chartType: GoogleChartWrapperChartType;
    data: (string | number)[][];
    options: any;
  }

  const columnChart1: ChartConfig = {
    width: "100%",
    height: "264px",
    chartType: "ColumnChart",
    data: chartData,
    options: {
      legend: { position: "top" },
      bar: { groupWidth: "70%" },
      colors: ["#307EF3", "#EBA31D", "#51bb25", "#f73164", "#a927f9"],
      vAxis: { format: "decimal" },
    },
  };

  return (
   
      <Col className={"col-sm-12 col-xl-6 box-col-6"}>
        <Card>
          <CardHeader className="d-flex justify-content-between align-items-center">
            <CardHeaderSpan
              headingClassName="pb-0 mb-0"
              heading="MtpStatusByDesignation"
            />
            <MonthDropdown onChange={(month) =>{
                console.log(month);
                
                setSelectedMonth(month)
            } } />
          </CardHeader>
          <CardBody className={"chart-block"}>
            <div className={"chart-overflow"}>
              {chartData.length > 1 ? (
                <Chart
                  width={columnChart1.width}
                  height={columnChart1.height}
                  chartType={columnChart1.chartType}
                  data={columnChart1.data}
                  options={columnChart1.options}
                  loader={<div>Loading Chart...</div>}
                />
              ) : (
                <div className="text-center text-muted">No data available</div>
              )}{" "}
            </div>
          </CardBody>
        </Card>
      </Col>
    
  );
};

export default MtpStatusByDesignation;
